import { ExternalDashboardCard } from '../ExternalDashboardCard/ExternalDashboardCard'
import styles from './styles.module.scss'

const CARDS = [
    {
        title: 'Sentinel CMS',
        description: 'Manage the Sentinel Legal website content and introducer form content',
        href: 'https://main.d1g9yf9cwgpadx.amplifyapp.com',
        colors: ['#0b1020', '#26113d', '#641b48', '#123b4b', '#11121c'] as const,
    },
    {
        title: 'Sentinel Studio',
        description: 'Preview sentinel native mobile app designs and user flows',
        href: 'https://main.d33tmzyx7ur538.amplifyapp.com',
        colors: ['#10141f', '#1b3358', '#2f6f8f', '#16324a', '#0e1520'] as const,
    },
    {
        title: 'Funding Audit',
        description: 'Open the funding audit pipeline to review and audit cases',
        href: 'https://audit-pipeline.sentinellab.ai/',
        colors: ['#16110a', '#3d2a12', '#8a5a1a', '#c49a3a', '#1a140c'] as const,
    },
]

export const ExternalDashboardCardGrid = () => (
    <div className={styles.grid}>
        {CARDS.map((card, index) => (
            <ExternalDashboardCard
                key={`${card.title}-${index}`}
                title={card.title}
                description={card.description}
                href={card.href}
                colors={card.colors}
            />
        ))}
    </div>
)

export default ExternalDashboardCardGrid
